export const SITE_KEYS_V3 = {
  ED: "6Lctb7whAAAAAII8xXV5upScHhLbBLja6b51aWT9",
  GO: "6LcCWrwhAAAAALzzpZdkkicmzUxoMzEomb3dOfbg",
  OP: "6LfPZ7whAAAAALMT8Ug3rgWZfrOjbrEZDtiNSQQp",
  TR: "6Le1YbwhAAAAAB0undIoh4MghTUbfh2NKr8pWibH",
};

export const SITE_KEYS_V2 = {
  ED: "6Lev4HEUAAAAAFV_b--rd80plrzNKeFkEaeIcaXJ",
  GO: "6LcV43EUAAAAAIPqczsFc3PI5dUEZI8EM_NRMXXT",
  OP: "6LcJ4HEUAAAAAJqHmTMtGsomNHx0DGCPUCxAMPl8",
  TR: "6LeJ5HEUAAAAANEEIRgsguE4FCdBS6hhcHrAVk2E",
  // QA
  // ED: "6Ld2wy4UAAAAAMKMIA69mC0Ej5d7FvYva-eRPety",
  // GO: "6Ld2wy4UAAAAAMKMIA69mC0Ej5d7FvYva-eRPety",
  // OP: "6Ld2wy4UAAAAAMKMIA69mC0Ej5d7FvYva-eRPety",
  // TR: "6Ld2wy4UAAAAAMKMIA69mC0Ej5d7FvYva-eRPety",
};

export const SITE_KEYS_V2_QA = "6Ld2wy4UAAAAAMKMIA69mC0Ej5d7FvYva-eRPety";
